/* Hot Sleeper Club – chrome.js: header, menu drawer, predictive search, footer disclosures, newsletter forms, email popup. */
const HSC = window.HSC;
const doc = document;
const root = doc.documentElement;
const { qs, qsa } = HSC.util;

const COOKIE_SUBSCRIBED = 'hsc_subscribed';
const COOKIE_DISMISSED = 'hsc_popup_dismissed';
const KEY_SHOWN = 'hsc_popup_shown';
const KEY_ATC = 'hsc_atc';

function getCookie(name) {
  const hit = doc.cookie.split('; ').find((c) => c.indexOf(name + '=') === 0);
  return hit ? hit.slice(name.length + 1) : '';
}
function setCookie(name, value, days) {
  doc.cookie = `${name}=${value}; max-age=${Math.max(1, Math.round(days * 86400))}; path=/; SameSite=Lax`;
}
function session(key, value) {
  try {
    if (value === undefined) return sessionStorage.getItem(key);
    sessionStorage.setItem(key, value);
  } catch (e) { return null; }
  return value;
}
function define(name, cls) {
  if (!customElements.get(name)) customElements.define(name, cls);
}

/* ---------- header (G.2): hide on scroll down, show on scroll up ---------- */
class HscHeader extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section') || this;
    this.mode = this.dataset.sticky || 'scroll_up';
    this.isHidden = false;
    this.lastY = Math.max(0, window.scrollY);
    this.anchorY = this.lastY;
    this.dir = 0;
    this.lastH = -1;

    this.onScroll = () => {
      if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); });
    };
    this.onFocusIn = () => this.setHidden(false);
    this.onToggle = (e) => {
      const d = e.target;
      if (!d.matches || !d.matches('[data-header-dropdown]') || !d.open) return;
      qsa('[data-header-dropdown][open]', this).forEach((o) => { if (o !== d) o.open = false; });
    };
    this.onDocClick = (e) => {
      qsa('[data-header-dropdown][open]', this).forEach((d) => { if (!d.contains(e.target)) d.open = false; });
    };
    this.onKey = (e) => {
      if (e.key !== 'Escape') return;
      const d = e.target.closest && e.target.closest('[data-header-dropdown][open]');
      if (d) { d.open = false; qs('summary', d).focus(); }
    };
    this.onFocusOut = (e) => {
      const d = e.target.closest && e.target.closest('[data-header-dropdown][open]');
      if (d && e.relatedTarget && !d.contains(e.relatedTarget)) d.open = false;
    };

    this.menu = doc.getElementById('MenuDrawer');
    this.onMenuClick = (e) => {
      const search = e.target.closest('[data-menu-search]');
      if (search) {
        e.preventDefault();
        const trigger = qs('[aria-controls="MenuDrawer"]', this);
        HSC.dialog.close(this.menu, { immediate: true, returnFocus: false });
        HSC.dialog.open('search', { trigger, focus: '[data-search-input]' });
        return;
      }
      if (e.target.closest('a[href]')) HSC.dialog.close(this.menu, { immediate: true, returnFocus: false });
    };
    this.mq = window.matchMedia('(min-width: 990px)');
    this.onMq = () => {
      if (this.mq.matches && this.menu && this.menu.open) HSC.dialog.close(this.menu, { immediate: true, returnFocus: false });
      qsa('[data-header-dropdown][open]', this).forEach((d) => { d.open = false; });
    };

    if (this.mode === 'scroll_up') window.addEventListener('scroll', this.onScroll, { passive: true });
    this.addEventListener('focusin', this.onFocusIn);
    this.addEventListener('toggle', this.onToggle, true);
    this.addEventListener('keydown', this.onKey);
    this.addEventListener('focusout', this.onFocusOut);
    doc.addEventListener('click', this.onDocClick);
    if (this.menu) this.menu.addEventListener('click', this.onMenuClick);
    this.mq.addEventListener('change', this.onMq);
    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(() => this.measure());
      this.ro.observe(this);
    }
    this.measure();
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.removeEventListener('focusin', this.onFocusIn);
    this.removeEventListener('toggle', this.onToggle, true);
    this.removeEventListener('keydown', this.onKey);
    this.removeEventListener('focusout', this.onFocusOut);
    doc.removeEventListener('click', this.onDocClick);
    if (this.menu) this.menu.removeEventListener('click', this.onMenuClick);
    this.mq.removeEventListener('change', this.onMq);
    if (this.ro) this.ro.disconnect();
    if (this.raf) cancelAnimationFrame(this.raf);
    this.section.classList.remove('is-header-hidden');
  }

  measure() {
    this.height = this.offsetHeight;
    let top = 0;
    let el = this.section.previousElementSibling;
    while (el) {
      if (el.classList.contains('shopify-section')) top += el.offsetHeight;
      el = el.previousElementSibling;
    }
    this.top = top;
    this.publish();
  }

  update() {
    const y = Math.max(0, window.scrollY);
    const dy = y - this.lastY;
    this.lastY = y;
    if (this.mode !== 'scroll_up') return;
    if (HSC.designMode) { this.setHidden(false); return; }
    if (HSC.dialog.anyOpen() || HSC.isProgrammaticScroll() || qs('[data-header-dropdown][open]', this)) {
      this.anchorY = y;
      return;
    }
    if (y <= this.top + this.height + 120) {
      this.anchorY = y;
      this.setHidden(false);
      return;
    }
    const dir = dy > 0 ? 1 : dy < 0 ? -1 : this.dir;
    if (dir !== this.dir) { this.anchorY = y - dy; this.dir = dir; }
    if (dir > 0 && y - this.anchorY >= 8) this.setHidden(true);
    else if (dir < 0 && this.anchorY - y >= 8) this.setHidden(false);
  }

  setHidden(hidden) {
    if (hidden === this.isHidden) return;
    this.isHidden = hidden;
    this.section.classList.toggle('is-header-hidden', hidden);
    if (hidden) qsa('[data-header-dropdown][open]', this).forEach((d) => { d.open = false; });
    this.publish();
  }

  publish() {
    const h = this.isHidden || this.mode === 'none' ? 0 : this.height || 0;
    if (h === this.lastH) return;
    this.lastH = h;
    root.style.setProperty('--header-visible-h', `${h}px`);
    HSC.bus.emit('header:change', { visible: h > 0, height: h });
  }
}
define('hsc-header', HscHeader);

/* ---------- --announce-h: the announcement bar's height (0px when the bar is off), for first-viewport sizing ---------- */
(function publishAnnounceHeight() {
  const set = () => {
    const bar = qs('.announcement-bar');
    root.style.setProperty('--announce-h', `${bar ? Math.round(bar.getBoundingClientRect().height) : 0}px`);
  };
  set();
  const bar = qs('.announcement-bar');
  if (bar && 'ResizeObserver' in window) new ResizeObserver(set).observe(bar);
})();

/* ---------- predictive search (I.2) ---------- */
class HscPredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = qs('[data-search-input]', this);
    this.results = qs('[data-search-results]', this);
    this.status = qs('[data-search-status]', this);
    this.clearBtn = qs('[data-search-clear]', this);
    if (!this.input || !this.results) return;
    this.cache = new Map();
    this.debounced = HSC.util.debounce(() => this.search(), 250);
    this.onInput = () => {
      this.toggleClear();
      if (this.term().length < 2) { this.reset(); return; }
      this.debounced();
    };
    this.onClear = () => {
      this.input.value = '';
      this.onInput();
      this.input.focus();
    };
    this.onKey = (e) => {
      if (e.key === 'Escape' && e.target === this.input) {
        e.preventDefault();
        HSC.dialog.close(this.closest('dialog'));
        return;
      }
      if (e.key !== 'ArrowDown' || e.target !== this.input) return;
      const first = qs('a[href]', this.results);
      if (first) { e.preventDefault(); first.focus(); }
    };
    this.input.addEventListener('input', this.onInput);
    if (this.clearBtn) this.clearBtn.addEventListener('click', this.onClear);
    this.addEventListener('keydown', this.onKey);
    this.offOpen = HSC.bus.on('dialog:open', (d) => {
      if (!d.dialog || !d.dialog.contains(this)) return;
      this.input.select();
      if (this.term().length >= 2 && !this.results.childElementCount) this.search();
    });
    this.toggleClear();
  }

  disconnectedCallback() {
    if (!this.input) return;
    this.reset();
    this.input.removeEventListener('input', this.onInput);
    if (this.clearBtn) this.clearBtn.removeEventListener('click', this.onClear);
    this.removeEventListener('keydown', this.onKey);
    if (this.offOpen) this.offOpen();
  }

  term() { return this.input.value.trim(); }

  toggleClear() { if (this.clearBtn) this.clearBtn.hidden = !this.input.value; }

  reset() {
    this.debounced.cancel();
    if (this.ctrl) this.ctrl.abort();
    this.ctrl = null;
    clearTimeout(this.loadTimer);
    this.results.innerHTML = '';
    this.setStatus('');
  }

  setStatus(text) {
    if (!this.status) return;
    this.status.textContent = '';
    if (text) setTimeout(() => { this.status.textContent = text; }, 60);
  }

  async search() {
    const q = this.term();
    if (q.length < 2) return;
    if (this.ctrl) this.ctrl.abort();
    clearTimeout(this.loadTimer);
    if (this.cache.has(q)) { this.show(this.cache.get(q)); return; }
    const ctrl = new AbortController();
    this.ctrl = ctrl;
    this.loadTimer = setTimeout(() => {
      this.results.innerHTML = '<div class="search-dialog__skeleton" aria-hidden="true"><span></span><span></span><span></span></div>';
    }, 300);
    const url = `${this.dataset.url}?q=${encodeURIComponent(q)}&resources[type]=product,page&resources[limit]=4&resources[options][unavailable_products]=last&section_id=${encodeURIComponent(this.dataset.section)}`;
    try {
      const res = await fetch(url, { signal: ctrl.signal, headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error(String(res.status));
      const tpl = doc.createElement('template');
      tpl.innerHTML = await res.text();
      const node = tpl.content.querySelector('[data-predictive-results]');
      const html = node ? node.outerHTML : '';
      this.cache.set(q, html);
      if (ctrl === this.ctrl && this.term() === q) this.show(html);
    } catch (err) {
      if (err.name !== 'AbortError' && ctrl === this.ctrl) this.error();
    } finally {
      if (ctrl === this.ctrl) { clearTimeout(this.loadTimer); this.ctrl = null; }
    }
  }

  show(html) {
    clearTimeout(this.loadTimer);
    this.results.innerHTML = html;
    /* red-team 26.10.2026: results cached in this tab follow the offer state ([data-promo-only] / [data-promo-off]) */
    if (window.HSC && HSC.promo) HSC.promo.apply(this.results);
    const r = qs('[data-predictive-results]', this.results);
    this.setStatus(r ? r.dataset.status : '');
  }

  /* "Search isn't working right now. Please try again, or [read our FAQ]." – the FAQ words inside the
     sentence become the link (matched case-insensitively); a translation without them gets the link after it. */
  error() {
    clearTimeout(this.loadTimer);
    const text = this.dataset.error || '';
    const label = this.dataset.faqLabel || '';
    const p = doc.createElement('p');
    p.className = 'search-dialog__message';
    const a = doc.createElement('a');
    a.href = this.dataset.faqUrl || (HSC.config.routes.root || '/').replace(/\/?$/, '/') + '?view=faq';
    const at = label ? text.toLowerCase().lastIndexOf(label.toLowerCase()) : -1;
    if (at >= 0) {
      a.textContent = text.slice(at, at + label.length);
      p.append(text.slice(0, at), a, text.slice(at + label.length));
    } else if (label) {
      a.textContent = label;
      p.append(`${text} `, a);
    } else {
      p.textContent = text;
    }
    this.results.replaceChildren(p);
    this.setStatus(text);
  }
}
define('hsc-predictive-search', HscPredictiveSearch);

/* ---------- footer link columns: disclosures under 750 px (G.4) ---------- */
class HscFooterNav extends HTMLElement {
  connectedCallback() {
    this.onClick = (e) => {
      const btn = e.target.closest('[data-footer-toggle]');
      if (!btn || !this.contains(btn)) return;
      const col = btn.closest('[data-footer-col]');
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      if (col) col.classList.toggle('is-open', open);
    };
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() { this.removeEventListener('click', this.onClick); }
}
define('hsc-footer-nav', HscFooterNav);

/* ---------- newsletter (footer + popup): native customer form, submitted in place ---------- */
class HscNewsletter extends HTMLElement {
  connectedCallback() {
    this.form = qs('form', this);
    if (!this.form) return;
    this.input = qs('input[type="email"]', this.form);
    this.btn = qs('[type="submit"]', this.form);
    this.errorEl = qs('[data-newsletter-error]', this);
    this.statusEl = qs('[data-newsletter-status]', this);
    this.tpl = qs('template[data-newsletter-success]', this);
    this.onSubmit = (e) => this.submit(e);
    this.onInput = () => { if (this.input.getAttribute('aria-invalid') === 'true') this.setError(false); };
    this.form.addEventListener('submit', this.onSubmit);
    this.input.addEventListener('input', this.onInput);
  }

  disconnectedCallback() {
    if (!this.form) return;
    this.form.removeEventListener('submit', this.onSubmit);
    this.input.removeEventListener('input', this.onInput);
  }

  valid() {
    const v = this.input.value.trim();
    return this.input.validity.valid && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  setError(on) {
    if (on) this.input.setAttribute('aria-invalid', 'true');
    else this.input.removeAttribute('aria-invalid');
    if (this.errorEl) this.errorEl.hidden = !on;
  }

  async submit(e) {
    e.preventDefault();
    if (this.busy) return;
    if (!this.valid()) { this.setError(true); this.input.focus(); return; }
    this.setError(false);
    this.busy = true;
    if (this.btn) { this.btn.classList.add('is-loading'); this.btn.setAttribute('aria-busy', 'true'); }
    const email = this.input.value.trim();
    try {
      const res = await HSC.util.fetchWithTimeout(this.form.action, { method: 'POST', body: new FormData(this.form), headers: { Accept: 'text/html' } }, 10000);
      if (!res.ok || /\/challenge/.test(res.url)) throw new Error('native');
      const page = new DOMParser().parseFromString(await res.text(), 'text/html');
      const posted = page.getElementById(this.form.id);
      const state = posted && posted.querySelector('[data-newsletter-state]');
      if (state && state.getAttribute('data-newsletter-state') === 'error') {
        this.setError(true);
        this.input.focus();
        return;
      }
      this.success(email);
    } catch (err) {
      this.form.submit();
    } finally {
      this.busy = false;
      if (this.btn) { this.btn.classList.remove('is-loading'); this.btn.removeAttribute('aria-busy'); }
    }
  }

  success(email) {
    setCookie(COOKIE_SUBSCRIBED, '1', 365);
    this.input.value = '';
    this.classList.add('is-subscribed');
    if (this.statusEl && this.tpl) this.statusEl.replaceChildren(this.tpl.content.cloneNode(true));
    this.dispatchEvent(new CustomEvent('newsletter:success', { bubbles: true, detail: { email } }));
  }
}
define('hsc-newsletter', HscNewsletter);

/* ---------- email popup (J) ---------- */
function e164(value) {
  const raw = String(value || '').trim();
  const digits = raw.replace(/\D/g, '');
  if (raw.charAt(0) === '+' && digits.length >= 11 && digits.length <= 15) return `+${digits}`;
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.charAt(0) === '1') return `+${digits}`;
  return '';
}

class HscEmailPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = qs('dialog', this);
    if (!this.dialog) return;
    this.cfg = HSC.config.popup || {};
    this.isPdp = HSC.config.template === 'product';
    this.smsForm = qs('[data-sms-form]', this);

    this.onSuccess = (e) => {
      this.subscribed = true;
      this.email = (e.detail && e.detail.email) || '';
      HSC.track('hsc_popup_submit', {});
      this.showStep(this.smsForm ? 'sms' : 'success');
    };
    this.onClick = (e) => {
      if (e.target.closest('[data-popup-skip]')) { e.preventDefault(); this.showStep('success'); return; }
      if (e.target.closest('a[href]')) HSC.dialog.close(this.dialog, { immediate: true, returnFocus: false });
    };
    this.onSms = (e) => this.sendSms(e);
    this.addEventListener('newsletter:success', this.onSuccess);
    this.dialog.addEventListener('click', this.onClick);
    if (this.smsForm) this.smsForm.addEventListener('submit', this.onSms);
    this.offClose = HSC.bus.on('dialog:close', (d) => { if (d.dialog === this.dialog) this.closed(); });
    this.offCart = HSC.bus.on('cart:updated', (d) => { if (!d || d.source !== 'refresh') session(KEY_ATC, '1'); });

    if (HSC.designMode || !this.cfg.enabled) return;
    if (this.suppressed()) return;
    this.arm();
  }

  disconnectedCallback() {
    if (!this.dialog) return;
    this.disarm();
    this.removeEventListener('newsletter:success', this.onSuccess);
    this.dialog.removeEventListener('click', this.onClick);
    if (this.smsForm) this.smsForm.removeEventListener('submit', this.onSms);
    if (this.offClose) this.offClose();
    if (this.offCart) this.offCart();
  }

  suppressed() {
    if (session(KEY_SHOWN) || session(KEY_ATC)) return true;
    if (getCookie(COOKIE_SUBSCRIBED) || getCookie(COOKIE_DISMISSED)) return true;
    const medium = (new URLSearchParams(window.location.search).get('utm_medium') || '').toLowerCase();
    if (medium === 'email' || medium === 'sms') { session(KEY_SHOWN, 'utm'); return true; }
    const state = HSC.cart && HSC.cart.state;
    const count = state && typeof state.item_count === 'number' ? state.item_count : Number((HSC.config.cart || {}).item_count || 0);
    return count > 0;
  }

  arm() {
    this.started = Date.now();
    const secs = Number(this.isPdp ? this.cfg.pdp_seconds : this.cfg.other_seconds) || (this.isPdp ? 40 : 15);
    const pct = Number(this.isPdp ? this.cfg.pdp_scroll : this.cfg.other_scroll) || (this.isPdp ? 50 : 40);
    this.timeOk = false;
    this.scrollOk = false;
    this.timer = setTimeout(() => { this.timeOk = true; this.check(); }, Math.max(5, secs) * 1000);
    this.onScroll = HSC.util.throttle(() => {
      const max = root.scrollHeight - window.innerHeight;
      if (max <= 0 || (window.scrollY / max) * 100 >= pct) this.scrollOk = true;
      this.check();
    }, 250);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    if (this.cfg.exit_intent && window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches) {
      this.onLeave = (e) => {
        if (!e.relatedTarget && e.clientY <= 0 && Date.now() - this.started > 5000) this.open();
      };
      doc.addEventListener('mouseout', this.onLeave);
    }
  }

  disarm() {
    clearTimeout(this.timer);
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    if (this.onLeave) doc.removeEventListener('mouseout', this.onLeave);
  }

  check() {
    const ok = this.isPdp ? this.timeOk && this.scrollOk : this.timeOk || this.scrollOk;
    if (ok) this.open();
  }

  open() {
    if (this.isShown) return;
    if (this.suppressed()) { this.disarm(); return; }
    if (HSC.dialog.anyOpen()) return;
    this.isShown = true;
    this.disarm();
    session(KEY_SHOWN, '1');
    HSC.dialog.open(this.dialog);
    HSC.track('hsc_popup_view', {});
    HSC.bus.emit('popup:open', {});
  }

  closed() {
    if (!HSC.designMode && !this.subscribed) setCookie(COOKIE_DISMISSED, '1', Number(this.cfg.suppress_days) || 14);
    HSC.bus.emit('popup:close', {});
  }

  showStep(name) {
    let target = null;
    qsa('[data-step]', this).forEach((step) => {
      const on = step.getAttribute('data-step') === name;
      step.hidden = !on;
      if (on) target = step;
    });
    const title = target && qs('[data-step-title]', target);
    if (title) title.focus({ preventScroll: true });
  }

  fieldError(el, show) {
    if (!el) return;
    el.hidden = !show;
  }

  async sendSms(e) {
    e.preventDefault();
    if (this.busy) return;
    const form = this.smsForm;
    const phoneInput = qs('input[type="tel"]', form);
    const consent = qs('input[type="checkbox"]', form);
    const phoneError = qs('[data-sms-error="phone"]', form);
    const consentError = qs('[data-sms-error="consent"]', form);
    const sendError = qs('[data-sms-error="send"]', form);
    const phone = e164(phoneInput.value);
    this.fieldError(phoneError, !phone);
    if (phone) phoneInput.removeAttribute('aria-invalid'); else phoneInput.setAttribute('aria-invalid', 'true');
    this.fieldError(consentError, phone && !consent.checked);
    this.fieldError(sendError, false);
    if (!phone) { phoneInput.focus(); return; }
    if (!consent.checked) { consent.focus(); return; }
    const btn = qs('[type="submit"]', form);
    this.busy = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'theme-popup',
          profile: { data: { type: 'profile', attributes: { email: this.email || undefined, phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } } } }
        },
        relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
      }
    };
    try {
      const res = await HSC.util.fetchWithTimeout(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(form.dataset.key)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      }, 10000);
      if (!res.ok) throw new Error(String(res.status));
      this.showStep('success');
    } catch (err) {
      this.fieldError(sendError, true);
    } finally {
      this.busy = false;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  }
}
define('hsc-email-popup', HscEmailPopup);
